export default {
  data: [
    {
      id: 0,
      gantt_id: 0,
      user_id: 0,
      skin: '4',
      name: 'String',
      token: 'String',
      last_update: 'String',
      import: null,
      is_shared: 0,
      is_removed: 0,
      is_jira: null,
      config: {},
      userConfig: null,
      userSkin: null,
      status: 'main',
      project_id: 0,
      teamLogo: null,
      teamName: 'Test',
      favicon: null,
      show_favicon: 0,
    },
  ],
};
